import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-setor-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-setor-obra.component.html',
  styleUrls: ['./filtro-setor-obra.component.scss'],
})
export class FiltroSetorObraComponent implements OnInit {
  @Input() bloqueandoAtualizacao: boolean = false;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  filtroSetorObra: Array<any> = [];
  @Input() idModuloSelecionado: number;
  @Input() setoresSelecionados: any[] = [];
  @Output() setorChange = new EventEmitter<any[]>();
  @Input() disabled: boolean = false;

  private subscriptions = new Subscription();

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private readonly _errorHandleService: ErrorHandleService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (this.idModuloSelecionado === 234 || this.bloqueandoAtualizacao) {
      return;
    }
    this.filtroSetorDaObra();
    if (changes.setoresSelecionados && this.filtroSetorObra.length > 0) {
      this.sincronizarSetoresSelecionados();
    }
  }

  sincronizarSetoresSelecionados() {
    if (!Array.isArray(this.setoresSelecionados)) return;
    const selecionadosIds = this.setoresSelecionados.map((s) => s.id);
    this.filtroSetorObra.forEach((item) => {
      item.checked = selecionadosIds.includes(item.id);
    });
  }

  onCheckboxChange() {
    const selecionados = this.filtroSetorObra.filter((o) => o['checked']);
    this.setorChange.emit(selecionados);
  }

  filtroSetorDaObra() {
    this.subscriptions.add(
      this._filtroBuscaService
        .filtroSetorDaObra(this.idModuloSelecionado)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.filtroSetorObra = res.data;
              this.sincronizarSetoresSelecionados();
            } else {
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
        })
    );
  }
}
